import service from '../../services';

/**
 * Busca uma apólice por grupo e valor FIPE.
 * @param {Object} objBuscaApolice - Objeto contendo os parâmetros da busca.
 * @param {number} objBuscaApolice.idEmpresa - O ID da empresa.
 * @param {number} objBuscaApolice.idGrupo - O ID do grupo.
 * @param {string} objBuscaApolice.valorFipe - O valor FIPE da apólice (formatado como por ex: 'R$ 6.333,00').
 * @returns {Promise<Object>} Um objeto representando a apólice encontrada.
 */
export async function buscaApolicePorValorFipe(objBuscaApolice) {
  try {
    objBuscaApolice.valorFipe = parseFloat(
      objBuscaApolice.valorFipe
        .split(' ')[1]
        .replace('.', '')
        .replace(',', '.'),
    );

    const apoliceResult = await service.post(
      'apolice',
      'buscar-por-fipe',
      objBuscaApolice,
    );

    const { data } = apoliceResult;
    const nenhumResultadoEncontrado = data.length === 0;
    const maisDeUmResultadoEncontrado = data.length > 1;

    if (nenhumResultadoEncontrado) {
      console.error({ objBuscaApolice, erro: 'Nenhuma apólice encontrada' });
      return null;
    }

    if (maisDeUmResultadoEncontrado) {
      console.error({
        objBuscaApolice,
        erro: 'Mais de uma apólice encontrada',
      });
      return null;
    }

    return data[0];
  } catch (error) {
    return error;
  }
}
